!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.nvznModels = t() : e.nvznModels = t();
}(global, function () {
  return function (e) {
    var t = {};

    function i(o) {
      if (t[o]) return t[o].exports;
      var r = t[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
    }

    return i.m = e, i.c = t, i.d = function (e, t, o) {
      i.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: o
      });
    }, i.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, i.t = function (e, t) {
      if (1 & t && (e = i(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var o = Object.create(null);
      if (i.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        i.d(o, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return o;
    }, i.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return i.d(t, "a", t), t;
    }, i.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, i.p = "", i(i.s = 1);
  }([function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.UserRole = void 0;
    var o = i(3);
    Object.defineProperty(t, "UserRole", {
      enumerable: !0,
      get: function get() {
        return o.UserRole;
      }
    });
  }, function (e, t, i) {
    "use strict";

    var o = this && this.__createBinding || (Object.create ? function (e, t, i, o) {
      void 0 === o && (o = i);
      var r = Object.getOwnPropertyDescriptor(t, i);
      r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
        enumerable: !0,
        get: function get() {
          return t[i];
        }
      }), Object.defineProperty(e, o, r);
    } : function (e, t, i, o) {
      void 0 === o && (o = i), e[o] = t[i];
    }),
        r = this && this.__exportStar || function (e, t) {
      for (var i in e) {
        "default" === i || Object.prototype.hasOwnProperty.call(t, i) || o(t, e, i);
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), r(i(2), t), r(i(0), t), r(i(4), t), r(i(6), t), r(i(8), t);
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.routes = t.Method = void 0;
    var o,
        r = i(0);
    !function (e) {
      e.CONNECT = "connect", e.DELETE = "delete", e.GET = "get", e.HEAD = "head", e.OPTIONS = "options", e.PATCH = "patch", e.POST = "post", e.PUT = "put", e.TRACE = "trace";
    }(o = t.Method || (t.Method = {}));
    var n = {
      path: "/auth/verify",
      method: o.POST,
      isPublic: !0
    },
        s = {
      path: "/auth/register",
      method: o.POST,
      isPublic: !0
    },
        u = {
      path: "/auth/login",
      method: o.POST,
      isPublic: !0
    },
        a = {
      path: "/auth/user",
      method: o.GET,
      isPublic: !1
    },
        d = {
      path: "/admin/user/:userUserId",
      method: o.DELETE,
      isPublic: !1,
      minimumRequiredRole: r.UserRole.ADMIN
    },
        l = {
      path: "/admin/users",
      method: o.GET,
      isPublic: !1,
      minimumRequiredRole: r.UserRole.ADMIN
    },
        c = {
      path: "/admin/user/:userUserId",
      method: o.GET,
      minimumRequiredRole: r.UserRole.ADMIN,
      isPublic: !1
    },
        p = {
      path: "/admin/invite",
      method: o.POST,
      isPublic: !1,
      minimumRequiredRole: r.UserRole.ADMIN
    },
        f = {
      path: "/admin/updateUser/:userUserId",
      method: o.PUT,
      isPublic: !1,
      minimumRequiredRole: r.UserRole.PUBLISHER
    },
        m = {
      path: "/admin/allAssets",
      method: o.GET,
      isPublic: !1,
      minimumRequiredRole: r.UserRole.ADMIN
    },
        b = {
      path: "/assets",
      method: o.POST,
      isPublic: !1
    },
        h = {
      path: "/assets",
      method: o.PUT,
      isPublic: !1
    },
        P = {
      path: "/assets/:uuid",
      method: o.GET,
      isPublic: !0
    },
        E = {
      path: "/assets",
      method: o.GET,
      isPublic: !1
    },
        g = {
      path: "/assets/public",
      method: o.GET,
      isPublic: !0
    },
        v = {
      path: "/banner",
      method: o.GET,
      isPublic: !0
    },
        T = {
      path: "/assets/status/:uuid",
      method: o.GET,
      isPublic: !1
    },
        _ = {
      path: "/assets/:uuid",
      method: o.DELETE,
      isPublic: !1
    },
        A = {
      path: "/assets/qr/:uuid",
      method: o.GET,
      isPublic: !0
    },
        O = {
      path: "/assets/reassign/:uuid",
      method: o.PUT,
      isPublic: !1,
      minimumRequiredRole: r.UserRole.ADMIN
    },
        M = {
      path: "/assets/duplicate",
      method: o.POST,
      isPublic: !1,
      minimumRequiredRole: r.UserRole.ADMIN
    },
        I = {
      path: void 0,
      method: void 0,
      isPublic: !0
    };
    t.routes = {
      admin: {
        getAllUsers: l,
        inviteUser: p,
        updateUser: f,
        getAllAssets: m,
        adminGetUser: c,
        reassignModel: O,
        duplicateModal: M
      },
      auth: {
        verify: n,
        register: s,
        login: u,
        getUser: a,
        deleteUser: d
      },
      assets: {
        getAsset: P,
        getAssetsForUser: E,
        assetUploadStatus: T,
        deleteAsset: _,
        uploadAsset: b,
        editAsset: h,
        qrCode: A,
        getPublicAssets: g,
        getBannerConfig: v
      },
      misc: {
        noop: I
      }
    };
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.UserRole = void 0, function (e) {
      e.SUPERADMIN = "superadmin", e.ADMIN = "admin", e.PUBLISHER = "publisher";
    }(t.UserRole || (t.UserRole = {}));
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InvitationStatus = void 0;
    var o = i(5);
    Object.defineProperty(t, "InvitationStatus", {
      enumerable: !0,
      get: function get() {
        return o.InvitationStatus;
      }
    });
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InvitationStatus = void 0, function (e) {
      e.REGISTERED = "registered", e.PENDING = "pending";
    }(t.InvitationStatus || (t.InvitationStatus = {}));
  }, function (e, t, i) {
    "use strict";

    var o = this && this.__createBinding || (Object.create ? function (e, t, i, o) {
      void 0 === o && (o = i);
      var r = Object.getOwnPropertyDescriptor(t, i);
      r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
        enumerable: !0,
        get: function get() {
          return t[i];
        }
      }), Object.defineProperty(e, o, r);
    } : function (e, t, i, o) {
      void 0 === o && (o = i), e[o] = t[i];
    }),
        r = this && this.__exportStar || function (e, t) {
      for (var i in e) {
        "default" === i || Object.prototype.hasOwnProperty.call(t, i) || o(t, e, i);
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), r(i(7), t);
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.BANNER_TYPE = t.AR_SCALE = t.DISTANCE = t.CAM_ANGLE = t.ANGLE = t.FILE_TYPE = t.IMAGE_TYPE = t.MODEL_ALIGNMENT = void 0, function (e) {
      e.center = "center", e.origin = "origin";
    }(t.MODEL_ALIGNMENT || (t.MODEL_ALIGNMENT = {})), function (e) {
      e.none = "", e.hdr = "hdr", e.jpg = "jpg", e.jpeg = "jpeg", e.png = "png";
    }(t.IMAGE_TYPE || (t.IMAGE_TYPE = {})), function (e) {
      e.glb = "glb", e.usdz = "usdz", e.backgroundImage = "backgroundImage", e.environmentalImage = "environmentalImage", e.posterImage = "poster", e.thumbnailImage = "thumbnail", e.previewImage = "preview";
    }(t.FILE_TYPE || (t.FILE_TYPE = {})), function (e) {
      e.degrees = "deg", e.radian = "rad";
    }(t.ANGLE || (t.ANGLE = {})), function (e) {
      e.auto = "auto", e.degrees = "deg", e.radian = "rad";
    }(t.CAM_ANGLE || (t.CAM_ANGLE = {})), function (e) {
      e.auto = "auto", e.milimeters = "mm", e.centimeters = "cm", e.meters = "m";
    }(t.DISTANCE || (t.DISTANCE = {})), function (e) {
      e.fixed = "fixed", e.auto = "auto";
    }(t.AR_SCALE || (t.AR_SCALE = {})), function (e) {
      e.buyNow = "buyNow", e.addToCart = "addToCart", e.addToBasket = "addToBasket", e.addToWishList = "addToWishList", e.addToFoodOrder = "addToFoodOrder";
    }(t.BANNER_TYPE || (t.BANNER_TYPE = {}));
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }]);
});